import { useQuery } from '@tanstack/react-query';
import { isHTTPError } from 'ky';

import { trialsApi } from './trials.api.js';
import { trialQueryKeys } from './trials.query-keys.js';

function queryRetry(count: number, err: unknown): boolean {
  return isHTTPError(err) ? false : count < 3;
}

/**
 * Whether the picked trial keeps a randomization number (card flag
 * `randomizationNumber`, B.1/B.2). When the trial is unknown, still loading or
 * missing, the answer is `false` — the UI hides the number instead of offering
 * a field the trial does not keep.
 */
export function useTrialRandomization(trialId: number | null | undefined): boolean {
  const id = trialId ?? 0;
  const enabled = id > 0;
  const trialQuery = useQuery({
    queryKey: trialQueryKeys.detail(id),
    queryFn: () => trialsApi.getTrial(id),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: queryRetry,
  });
  return trialQuery.data?.randomizationNumber ?? false;
}